import Axios from 'axios'
import { axiosInstance } from './axios'
import { configUrl } from '@/lib/configUrl'
import { installAxios, uninstallAxios, getLanguageTypeForChinese } from '@monsters/behavior-verification-cloyster/libs/captcha'
import { Message } from 'element-ui'
import {
	init
} from '@monsters/behavior-verification-cloyster/libs/password'

// 常量提取
const SCENE_MAP = {
	login: process.env.VUE_APP_GEE_LOGIN_SCENE,
	regist: process.env.VUE_APP_GEE_REGIST_SCENE,
	registEmail: process.env.VUE_APP_GEE_REGIST_EMAIL_SCENE,
	registMsg: process.env.VUE_APP_GEE_REGIST_MSG_SCENE,
	forgetPwd: process.env.VUE_APP_GEE_FORGETPWD_EMAIL_SCENE,
	contact: process.env.VUE_APP_GEE_CONTACT_SECRET

}

const REGION_MAP = {
	dev: 'CN',
	development: 'CN',
	fra: 'EU',
	pci: 'EU',
	ro: 'EU',
	production: 'EU',
	'production-us': 'US',
	sandbox: 'CN',
	test: 'HK'
}

const ENV_MAP = {
	dev: 'DEV',
	development: 'TEST',
	fra: 'PROD',
	pci: 'PROD',
	ro: 'PROD',
	production: 'PROD',
	'production-us': 'PROD',
	sandbox: 'SANDBOX',
	test: 'TEST'
}
const PASSWORD_REGION_MAP = {
	dev: 'CN',
	development: 'CN',
	fra: 'EU',
	pci: 'EU',
	ro: 'EU',
	production: 'EU',
	sandbox: 'CN',
	test: 'HK'
}
const ENV_MAP_PASSWORD = {
	dev: 'DEV',
	development: 'DEV',
	fra: 'PROD',
	pci: 'PROD',
	ro: 'PROD',
	production: 'PROD',
	'production-us': 'PROD',
	sandbox: 'TEST',
	test: 'TEST'
}

const DECRYPT_CONFIG = {
	key: 'f8e7d6c5b4a3928170615243a1b2c3d4',
	iv: '1a2b3c4d5e6f7a8b'
}

// 创建axios实例
const createMonstersInstance = () => {
	const instance = Axios.create({
		baseURL: configUrl
	})

	instance.interceptors.response.use(
		response => response,
		error => Promise.reject(error)
	)

	return instance
}

const monstersInstance = createMonstersInstance()

// 验证码配置生成器
const getCaptchaConfig = (scene) => {
	const getScene = () => {
		const sceneValue = SCENE_MAP[scene]
		if (!sceneValue) {
			console.error(`Invalid scene: ${scene}`)
			return ''
		}
		return sceneValue
	}

	return {
		env: ENV_MAP[process.env.NODE_ENV] || 'PROD',
		region: REGION_MAP[process.env.NODE_ENV] || 'EU',
		scene: getScene,
		blackBox: window.__pp_blackbox__,
		metaConfig: {
			appId: process.env.VUE_APP_GEE_APPID,
			secret: process.env.VUE_APP_GEE_SECRET
		},
		decrypt: DECRYPT_CONFIG,
		languageType: getLanguageTypeForChinese,
		needRefresh: (res) => handleResponseData(res)?.statusCode === 110
	}
}

// 响应处理器
export const handleResponseData = (response, needToast = true) => {
	const { status, data: axiosData, config } = response || {}

	const token = config.headers['X-CAPTCHA-TOKEN']
	const verifyCode = config.headers['X-CAPTCHA-VERIFY-BODY']
	// 缓存极验返回的认证信息
	window.sessionStorage.setItem('X-CAPTCHA-TOKEN', token)
	window.sessionStorage.setItem('X-CAPTCHA-VERIFY-BODY', verifyCode)

	if (!axiosData || status !== 200 || axiosData?.code !== 200) {
		const message = axiosData?.msg || window.vm.$i18n.t('components.global.netBusy')

		needToast && Message({
			duration: 5000,
			type: 'error',
			message
		})
		return null
	}

	return axiosData.data || null
}

// 响应处理器 直接返回后端信息
export const handleResponse = (response) => {
	const { data: axiosData } = response || {}

	return axiosData
}

// 带验证码的请求发送
export const sendRequestWithGeeTest = ([method, url], params, options) =>
	axiosInstance(monstersInstance, [method, url], params, options)

// 拦截器管理器
const interceptorsManager = {
	current: null
}

// 初始化验证码
export const initAxiosWithGeeTest = (scene) => {
	if (interceptorsManager.current) {
		uninstallAxios(monstersInstance, interceptorsManager.current)
	}

	interceptorsManager.current = installAxios(
		monstersInstance,
		getCaptchaConfig(scene)
	)
}

export const initPassword = () => {
	// console.log('initPassword===', REGION_MAP[process.env.NODE_ENV])
	init({
		env: ENV_MAP_PASSWORD[process.env.NODE_ENV] || 'PROD',
		region: PASSWORD_REGION_MAP[process.env.NODE_ENV] || 'EU',
		metaConfig: {
			appId: process.env.VUE_APP_GEE_APPID,
			secret: process.env.VUE_APP_GEE_SECRET
		}
	})
}
